import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'

const object = vnObject

const updateInfoForm = $('.js-update-account-form')

if (updateInfoForm.length) {
    updateInfoForm.parsley().on('form:success', function () {
        updateInfoForm.attr('data-success', 'true')
    })

    updateInfoForm.parsley().on('form:error', function () {
        updateInfoForm.attr('data-success', 'false')
    })

    updateInfoForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(updateInfoForm[0])
        formData.append('action', 'vn_update_info')
        formData.append('nonce', object.nonce)

        const $form = $(this)
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')

                Alert(res.success, res.data.message)
            },
        })
    })
}
